import React, { useState, useEffect } from 'react';
import { Home, User, BookOpen, Briefcase, MessageCircle, FolderOpen } from 'lucide-react';
import './nav.css';

// Define navItems outside component to prevent recreation on every render
const navItems = [
    { id: '#home', icon: Home, label: 'Home' },
    { id: '#about', icon: User, label: 'About' },
    { id: '#experience', icon: BookOpen, label: 'Experience' },
    { id: '#portfolio', icon: FolderOpen, label: 'Portfolio' },
    { id: '#services', icon: Briefcase, label: 'Services' },
    { id: '#contact', icon: MessageCircle, label: 'Contact' }
];

const Nav = () => {
    const [activeNav, setActiveNav] = useState('#home');

    // Handle scroll to update active nav
    useEffect(() => {
        const handleScroll = () => {
            const sections = navItems.map(item => document.querySelector(item.id));
            const scrollPosition = window.scrollY + 50;

            for (let i = sections.length - 1; i >= 0; i--) {
                const section = sections[i];
                if (section && section.offsetTop <= scrollPosition) {
                    setActiveNav(navItems[i].id);
                    break;
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleNavClick = (navId) => {
        setActiveNav(navId);
        const element = document.querySelector(navId);
        if (element) {
            const offsetTop = element.offsetTop;
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            });
        }
    };

        return (
        <nav className="nav-container">
            {navItems.map(({ id, icon: Icon, label }) => (
                <button
                    key={id}
                    onClick={() => handleNavClick(id)}
                    className={`nav-button ${activeNav === id ? 'active' : ''}`}
                    data-label={label}
                    aria-label={`Navigate to ${label} section`}
                    tabIndex={0}
                >
                    <Icon size={20} />
                </button>
            ))}
        </nav>
    );
};

export default Nav;